//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";
import { getIncorporateOverview } from "@/services/api-dtime/api_incorporate";

export default {
  name: "incorporate-overview",
  data() {
    return {
      loading: true,
      dueWithinDays: 30,

      // ⭐ ค่าจาก backend (GET /incorporate/incorporate-docket-overview)
      stats: {
        overdue: 0,
        due_soon: 0,
        in_progress: 0,
        request_payment: 0,
        complete: 0,
        cancelled: 0,
        total: 0,
        active_matters: 0,
      },
      byDocCategory: [],
      byAgency: [],
      urgentDockets: [],
    };
  },
  computed: {
    todayLabel() {
      try {
        return new Date().toLocaleDateString("th-TH", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      } catch {
        return "";
      }
    },

    // จำนวนรายการรอดำเนินการ = ทุกอย่างที่ยังไม่ Complete/Cancelled
    pendingTotal() {
      return (
        this.stats.overdue +
        this.stats.due_soon +
        Math.max(
          this.stats.in_progress - this.stats.overdue - this.stats.due_soon,
          0,
        ) +
        this.stats.request_payment
      );
    },

    statCards() {
      return [
        {
          key: "overdue",
          emoji: "🔴",
          label: "Overdue",
          value: this.stats.overdue,
          sub: "เกินกำหนดยื่น",
          color: "#dc2626",
          route: "/incorporate-docket-list",
        },
        {
          key: "due_soon",
          emoji: "🟡",
          label: "Due ≤ 7 วัน",
          value: this.stats.due_soon,
          sub: "ใกล้ครบกำหนด",
          color: "#d97706",
          route: "/incorporate-docket-list",
        },
        {
          key: "in_progress",
          emoji: "🔵",
          label: "In Progress",
          value: this.stats.in_progress,
          sub: "กำลังดำเนินการ",
          color: "#2563eb",
          route: "/incorporate-docket-list",
        },
        {
          key: "request_payment",
          emoji: "💗",
          label: "Request Payment",
          value: this.stats.request_payment,
          sub: "รอเรียกเก็บเงิน",
          color: "#db2777",
          route: "/incorporate-docket-list",
        },
        {
          key: "complete",
          emoji: "🟢",
          label: "Complete",
          value: this.stats.complete,
          sub: "เสร็จสิ้น",
          color: "#16a34a",
          route: "/incorporate-docket-list",
        },
        {
          key: "active_matters",
          emoji: "⚪",
          label: "Active Matters",
          value: this.stats.active_matters,
          sub: "แฟ้มที่ Active",
          color: "#6b7280",
          route: "/incorporate-matter-list",
        },
      ];
    },

    // รายการใกล้ครบกำหนด (ไม่รวม Request Payment เพราะแสดงในฝั่ง Urgent แล้ว)
    // ใช้สำหรับ block "Docket ที่ใกล้ครบกำหนด" ด้านขวา (เรียงตามวันที่ใกล้สุด)
    upcomingDockets() {
      return this.urgentDockets
        .filter((d) => d.status !== "Request Payment" && d.next_due_date)
        .slice()
        .sort((a, b) => new Date(a.next_due_date) - new Date(b.next_due_date))
        .slice(0, 5);
    },

    maxAgencyTotal() {
      if (!this.byAgency.length) return 1;
      return Math.max(...this.byAgency.map((r) => parseInt(r.total) || 0), 1);
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader && this.$hideLoader();
    await this.loadOverview();
  },
  methods: {
    async loadOverview() {
      this.loading = true;
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getIncorporateOverview(
          company_id,
          this.dueWithinDays,
        );
        const data = res.data || {};
        this.stats = { ...this.stats, ...(data.stats || {}) };
        this.byDocCategory = data.by_doc_category || [];
        this.byAgency = data.by_agency || [];
        this.urgentDockets = data.urgent_dockets || [];
      } catch (error) {
        console.error("Error loading incorporate overview:", error);
      } finally {
        this.loading = false;
      }
    },

    goToDocket(id) {
      this.$router.push(`/incorporate-docket-view/${id}`);
    },

    daysUntil(dateStr) {
      if (!dateStr) return null;
      const due = new Date(dateStr);
      const today = new Date();
      due.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return Math.round((due - today) / (1000 * 60 * 60 * 24));
    },

    isOverdue(d) {
      if (d.status === "Request Payment") return false;
      const days = this.daysUntil(d.next_due_date);
      return days !== null && days < 0;
    },

    urgentIcon(d) {
      if (d.status === "Request Payment") return "🧾";
      if (this.isOverdue(d)) return "⏰";
      return "📄";
    },

    urgentCardClass(d) {
      if (d.status === "Request Payment") return "card-pink";
      if (this.isOverdue(d)) return "card-red";
      const days = this.daysUntil(d.next_due_date);
      if (days !== null && days <= 7) return "card-yellow";
      return "card-blue";
    },

    urgentTagColor(d) {
      if (d.status === "Request Payment") return "pink lighten-4";
      if (this.isOverdue(d)) return "red lighten-4";
      return "amber lighten-4";
    },

    urgentTagLabel(d) {
      if (d.status === "Request Payment") return "REQ. PAYMENT";
      if (this.isOverdue(d)) return "OVERDUE";
      const days = this.daysUntil(d.next_due_date);
      return days !== null ? `${days} วัน` : "-";
    },

    urgentDaysColor(d) {
      if (d.status === "Request Payment") return "#db2777";
      if (this.isOverdue(d)) return "#dc2626";
      const days = this.daysUntil(d.next_due_date);
      if (days !== null && days <= 7) return "#d97706";
      return "#2563eb";
    },

    urgentDaysLabel(d) {
      if (d.status === "Request Payment") return "฿";
      const days = this.daysUntil(d.next_due_date);
      if (days === null) return "-";
      return days < 0 ? `${days}d` : `${days}d`;
    },

    upcomingChipColor(d) {
      const days = this.daysUntil(d.next_due_date);
      if (days === null) return "grey lighten-3";
      if (days < 0) return "red lighten-4";
      if (days <= 7) return "amber lighten-4";
      return "green lighten-4";
    },

    agencyBarWidth(row) {
      const total = parseInt(row.total) || 0;
      return Math.round((total / this.maxAgencyTotal) * 100);
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        return new Date(dateStr).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch {
        return dateStr;
      }
    },

    formatDateShort(dateStr) {
      if (!dateStr) return "-";
      try {
        return new Date(dateStr).toLocaleDateString("th-TH", {
          month: "2-digit",
          day: "2-digit",
        });
      } catch {
        return dateStr;
      }
    },
  },
};
